import { guaranteesClientText } from '~/modules/guarantees/form/client/constants.ts';

export const formatGuaranteesSummaryValue = (value: unknown): string => {
  if (value === undefined || value === null || value === '') {
    return guaranteesClientText.emptyValue;
  }

  if (typeof value === 'boolean') {
    return value ? 'Так' : 'Ні';
  }

  return String(value);
};
